import * as actionTypes from '@store/actions/actionTypes'
import { orderByOptions } from '@util/constants'
import { deepMerge } from '@util/functions'

const initialState = {
  networks: {
    networks: {
      sortBy: 'modified',
      orderBy: 'desc',
      view: 'small',
      controls: {
        sorts: [{ value: 'modified', label: 'Most Recent' }],
        orders: orderByOptions,
        views: ['small', 'large', 'list'],
        mobileViews: ['small', 'list']
      }
    },
    contacts: {
      sortBy: 'name',
      orderBy: 'asc',
      view: 'small',
      controls: {
        sorts: [
          { value: 'created', label: 'Most Recent' },
          { value: 'name', label: 'Name' },
          { value: 'modified', label: 'Recent Activity' }
        ],
        orders: orderByOptions,
        views: ['small', 'large', 'list'],
        mobileViews: ['small', 'list']
      }
    }
  },
  user: {
    favorites: {
      orderBy: 'asc',
      view: 'small',
      sortBy: 'status',
      controls: {
        orders: orderByOptions,
        views: ['small', 'list'],
        mobileViews: [],
        sorts: [
          { value: 'status', label: 'Status' },
          { value: 'price', label: 'Price' },
          { value: 'statusDate', label: 'Status Date' },
          { value: 'sqFt', label: 'Sq Ft' },
          { value: 'lotSqFt', label: 'Lot Size' },
          { value: 'yearBuilt', label: 'Year Built' }
        ]
      }
    },
    hides: {
      orderBy: 'asc',
      view: 'small',
      sortBy: 'status',
      controls: {
        orders: orderByOptions,
        views: ['small', 'list'],
        mobileViews: [],
        sorts: [
          { value: 'status', label: 'Status' },
          { value: 'price', label: 'Price' },
          { value: 'statusDate', label: 'Status Date' },
          { value: 'sqFt', label: 'Sq Ft' },
          { value: 'lotSqFt', label: 'Lot Size' },
          { value: 'yearBuilt', label: 'Year Built' }
        ]
      }
    },
    lists: {
      sortBy: 'name',
      orderBy: 'asc',
      view: 'large',
      controls: {
        orders: orderByOptions,
        sorts: [
          { value: 'created', label: 'Most Recent' },
          { value: 'name', label: 'Name' },
          { value: 'updated', label: 'Recent Activity' }
        ],
        views: ['small', 'large', 'list'],
        mobileViews: ['small', 'list']
      }
    },
    searches: {
      sortBy: 'name',
      orderBy: 'asc',
      view: 'large',
      controls: {
        orders: orderByOptions,
        sorts: [
          { value: 'name', label: 'Name' },
          { value: 'modified', label: 'Last Modified' }
        ],
        views: ['small', 'large', 'list'],
        mobileViews: ['small', 'list']
      }
    },
    evaluators: {
      sortBy: 'name',
      orderBy: 'asc',
      view: 'large',
      controls: {
        orders: orderByOptions,
        sorts: [
          { value: 'name', label: 'Name' },
          { value: 'modified', label: 'Last Modified' }
        ],
        views: ['small', 'large', 'list'],
        mobileViews: ['small', 'list']
      }
    }
  },
  offices: {
    offices: {
      orderBy: 'asc',
      sortBy: 'random',
      officeName: '',
      cityZip: '',
      start: 0,
      controls: {
        orders: orderByOptions,
        sorts: [
          { value: 'random', label: 'Randomized' },
          { value: 'name', label: 'Office Name' },
          { value: 'score', label: 'Best Match' }
        ],
        views: [],
        mobileViews: []
      }
    },
    agents: {
      orderBy: 'asc',
      sortBy: 'random',
      agentName: '',
      start: 0,
      controls: {
        orders: orderByOptions,
        sorts: [
          { value: 'random', label: 'Randomized' },
          { value: 'name', label: 'Agent Name' },
          { value: 'score', label: 'Best Match' }
        ]
      }
    }
  },
  agents: {
    agents: {
      orderBy: 'asc',
      sortBy: 'random',
      agentName: '',
      cityZip: '',
      start: 0,
      controls: {
        orders: orderByOptions,
        sorts: [
          { value: 'random', label: 'Randomized' },
          { value: 'lastName', label: 'Agent Name' },
          { value: 'score', label: 'Best Match' }
        ],
        views: [],
        mobileViews: []
      }
    }
  },
  network: {
    favorites: {
      membersLogic: 'or',
      orderBy: 'asc',
      sortBy: 'status',
      view: 'small',
      controls: {
        orders: orderByOptions,
        views: ['small'],
        mobileViews: ['small'],
        sorts: [
          { value: 'status', label: 'Status' },
          { value: 'price', label: 'Price' },
          { value: 'statusDate', label: 'Status Date' },
          { value: 'sqFt', label: 'Sq Ft' },
          { value: 'lotSqFt', label: 'Lot Size' },
          { value: 'yearBuilt', label: 'Year Built' }
        ]
      }
    },
    hides: {
      membersLogic: 'or',
      orderBy: 'asc',
      sortBy: 'status',
      view: 'small',
      controls: {
        orders: orderByOptions,
        views: ['small'],
        mobileViews: ['small'],
        sorts: [
          { value: 'status', label: 'Status' },
          { value: 'price', label: 'Price' },
          { value: 'statusDate', label: 'Status Date' },
          { value: 'sqFt', label: 'Sq Ft' },
          { value: 'lotSqFt', label: 'Lot Size' },
          { value: 'yearBuilt', label: 'Year Built' }
        ]
      }
    },
    searches: {
      sortBy: 'name',
      orderBy: 'asc',
      view: 'large',
      controls: {
        orders: orderByOptions,
        sorts: [
          { value: 'name', label: 'Name' },
          { value: 'modified', label: 'Last Modified' }
        ],
        views: ['small', 'large', 'list'],
        mobileViews: []
      }
    },
    lists: {
      sortBy: 'name',
      orderBy: 'asc',
      view: 'large',
      controls: {
        orders: orderByOptions,
        sorts: [
          { value: 'created', label: 'Most Recent' },
          { value: 'name', label: 'Name' }
        ],
        views: ['small', 'large', 'list'],
        mobileViews: []
      }
    },
    evaluators: {
      sortBy: 'name',
      orderBy: 'asc',
      view: 'large',
      controls: {
        orders: orderByOptions,
        views: ['small', 'large', 'list'],
        mobileViews: [],
        sorts: [
          { value: 'name', label: 'Name' },
          { value: 'modified', label: 'Last Modified' }
        ]
      }
    }
  },
  parcel: {
    listings: {
      orderBy: 'asc',
      view: 'small',
      controls: {
        orders: orderByOptions,
        views: ['small', 'list']
      }
    }
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_CONTEXT:
      return {
        ...state,
        [action.group]: {
          ...state[action.group],
          [action.view]: action.obj
        }
      }
    case actionTypes.SET_REFRESH_SCREEN:
      return {
        ...state,
        refreshScreen: action.bool
      }
    case actionTypes.SET_USER_VIEW_CONTEXT_PREFERENCES:
      return deepMerge(state, action.obj)
    default:
      return state
  }
}

export default reducer
